import { useEffect } from 'react';
import _ from 'lodash';
import {
    ADOBE_TOPICS,
    COMMON_TAGGING_PROPERTIES,
    SMI_TAGGING_PROPERTIES,
    SgProductService,
    useSgAdobeAnalyticsForWizard, SgSessionStorageService, CommonAdobeAnalyticsUtil
} from 'saga-modules';
import SgSmiCookieUtils from 'sg-smi-cookie-utils';
import { publish } from '@jutro/events';
import {
    SG_AA_PAGE_TYPE,
    SG_AA_QUOTE_TYPE
} from './AdobeAnalyticsConstants';

function useSgAdobeAnalyticsSmiIpidAndRetrieval() {
    const model = SgSessionStorageService.getItem(SgSessionStorageService.KEY.MODEL);
    useSgAdobeAnalyticsForWizard({ modelVM: model });

    /**
     * Tracks SMI IPID page adobe tags
     */
    function populateSmiIPIDAdobeTags() {
        if (SgSessionStorageService.getItem(SgSessionStorageService.KEY.IS_RETRIEVAL_JOURNEY)) {
            publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: COMMON_TAGGING_PROPERTIES.BHquoteType, value: SG_AA_QUOTE_TYPE.QUOTE_RETRIEVE });
        }
        const initialTagging = [
            { adobeID: SMI_TAGGING_PROPERTIES.pageType, value: SG_AA_PAGE_TYPE.QUOTE },
            { adobeID: COMMON_TAGGING_PROPERTIES.productName, value: SgProductService.getInsuranceProductName() }
        ];
        _.each(initialTagging, (taggingValue) => {
            publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: taggingValue.adobeID, value: taggingValue.value });
        });
    }

    /**
     * Tracks SMI retrieval page adobe tags when page is initializing
     */
    function populateSmiRetrievalAdobeTags() {
        const initialTagging = [
            { adobeID: COMMON_TAGGING_PROPERTIES.BHquoteType, value: SG_AA_QUOTE_TYPE.QUOTE_RETRIEVE },
            { adobeID: COMMON_TAGGING_PROPERTIES.loginStatus, value: CommonAdobeAnalyticsUtil.getLoggedInStatus() },
            { adobeID: COMMON_TAGGING_PROPERTIES.productName, value: SgProductService.getInsuranceProductName() },
            { adobeID: SMI_TAGGING_PROPERTIES.hasPrivateHealthInsurance, value: SgSmiCookieUtils.getVosCookieAsBoolean() },
            { adobeID: COMMON_TAGGING_PROPERTIES.productCategory, value: SgProductService.getProductCategory() }
        ];
        _.each(initialTagging, (taggingValue) => {
            publish(ADOBE_TOPICS.ADOBE_EVENT, { adobeID: taggingValue.adobeID, value: taggingValue.value });
        });
    }

    useEffect(() => {
        const currentPage = CommonAdobeAnalyticsUtil.getCurrentPageName();
        if (SgProductService.isSmi()) {
            if (currentPage.toLowerCase() === SG_AA_PAGE_TYPE.IPID) {
                populateSmiIPIDAdobeTags();
            }
            if (currentPage.toLowerCase() === SG_AA_PAGE_TYPE.RETRIEVAL) {
                populateSmiRetrievalAdobeTags();
            }
        }
    }, []);
}

export default useSgAdobeAnalyticsSmiIpidAndRetrieval;
